<div>
	<nz-table
		#reportingTable
		[nzShowPagination]="true"
		[nzFrontPagination]="true"
		[nzPaginationPosition]="'both'"
		[nzPageIndex]="selectedPageIndex()"
		[nzPageSize]="selectedPageSize()"
		[nzPageSizeOptions]="[5, 10, 20, 50, 100, 250, 1000]"
		[nzTotal]="rows().length"
		[nzData]="rows()"
		[nzLoading]="loading()"
		[nzShowSizeChanger]="true"
		[nzBordered]="false"
		[nzShowTotal]="totalTemplate"
		(nzQueryParams)="onQueryParamsChange($event)"
	>
		<thead>
			@if (columnsWithFilterState().length > 0) {
				<tr>
					@for (column of columnsWithFilterState(); track column.key) {
						@switch (column.key) {
							@case (ENABLE_CHECKBOX_COLUMN.key) {
								<th
									[nzSelections]="selectionOptions"
									[nzChecked]="checkedUuids.size === rows().length"
									[nzIndeterminate]="checkedUuids.size > 0 && checkedUuids.size < rows().length"
									(nzCheckedChange)="onAllChecked($event)"
									class="single-icon"
								></th>
							}
							@case (ENABLE_DISPLAY_ORDER_COLUMN.key) {
								<th [nzColumnKey]="column.key" class="single-icon"></th>
							}
							@case (ENABLE_UP_DOWN_COLUMN.key) {
								<th [nzColumnKey]="column.key" class="double-icon"></th>
							}
							@case (ENABLE_COPY_COLUMN.key) {
								<th [nzColumnKey]="column.key" class="single-icon"></th>
							}
							@case (ENABLE_EDIT_COLUMN.key) {
								<th [nzColumnKey]="column.key" class="single-icon"></th>
							}
							@case (ENABLE_DELETE_COLUMN.key) {
								<th [nzColumnKey]="column.key" class="single-icon"></th>
							}
							@case (ENABLE_PREVIEW_COLUMN.key) {
								<th [nzColumnKey]="column.key" class="single-icon"></th>
							}
							@default {
								<th
									[nzColumnKey]="column.key"
									[nzSortOrder]="column.sortOrder ? column.sortOrder : null"
									[nzSortFn]="column.sortFn ? column.sortFn : null"
									[nzSortDirections]="
										column.sortDirections ? column.sortDirections : ['ascend', 'descend', null]
									"
									[nzShowSort]="column.sortFn ? true : false"
									[nzShowFilter]="column.filterOptions ? true : false"
									[nzFilterMultiple]="column.filterMultiple ? column.filterMultiple : false"
									[nzFilters]="column.filterOptions ? column.filterOptions : []"
									[nzFilterFn]="column.filterFn ? column.filterFn : null"
									(nzFilterChange)="onColumnFilterChange(column.key, $event)"
								>
									<ng-container *ngTemplateOutlet="headerMap.get(column.key)"></ng-container>
								</th>
							}
						}
					}
				</tr>
			}
		</thead>
		<tbody>
			@for (row of reportingTable.data; track getRowId(row) || $index; let i = $index) {
				<tr
					class="row"
					[class.selected]="selectedUuid() !== undefined && selectedUuid() === getRowId(row)"
					[class.previewing]="previewingUuid() !== undefined && previewingUuid() === getRowId(row)"
				>
					@for (column of columnsWithFilterState(); track column.key) {
						@switch (column.key) {
							@case (ENABLE_CHECKBOX_COLUMN.key) {
								<td
									[nzChecked]="checkedUuids.has(getRowId(row)!)"
									(nzCheckedChange)="onCheckedChange(getRowId(row)!, $event)"
								></td>
							}
							@case (ENABLE_DISPLAY_ORDER_COLUMN.key) {
								<td>
									{{ getDisplayOrder(row) }}
								</td>
							}
							@case (ENABLE_UP_DOWN_COLUMN.key) {
								<td>
									<button
										nz-button
										nzType="text"
										nzShape="circle"
										nzSize="small"
										title="Move Up"
										(click)="onMoveUp.emit(row)"
									>
										<span nz-icon nzType="up" nzTheme="outline"></span>
									</button>
									<button
										nz-button
										nzType="text"
										nzShape="circle"
										nzSize="small"
										title="Move Down"
										(click)="onMoveDown.emit(row)"
									>
										<span nz-icon nzType="down" nzTheme="outline"></span>
									</button>
								</td>
							}
							@case (ENABLE_COPY_COLUMN.key) {
								<td>
									<button
										nz-button
										nzType="text"
										nzShape="circle"
										nzSize="small"
										title="Copy"
										(click)="onCopy.emit(row)"
									>
										<span nz-icon nzType="copy" nzTheme="outline"></span>
									</button>
								</td>
							}
							@case (ENABLE_EDIT_COLUMN.key) {
								<td>
									<button
										nz-button
										nzType="text"
										nzShape="circle"
										nzSize="small"
										(click)="onEdit.emit(row)"
										title="Edit"
									>
										<span nz-icon nzType="edit" nzTheme="outline"></span>
									</button>
								</td>
							}
							@case (ENABLE_DELETE_COLUMN.key) {
								<td>
									<button
										nz-button
										nzType="text"
										nzShape="circle"
										nzSize="small"
										nz-popconfirm
										nzPopconfirmTitle="Are you sure delete this?"
										nzPopconfirmPlacement="bottom"
										(nzOnConfirm)="onDelete.emit(row)"
										title="Delete"
										[disabled]="isInProgress(row) && !canWeDeleteInProgressCourseWork()"
										[nz-tooltip]="
											isInProgress(row) && !canWeDeleteInProgressCourseWork()
												? 'You cannot delete this item because it is in progress.'
												: ''
										"
									>
										<span nz-icon nzType="delete" nzTheme="outline"></span>
									</button>
								</td>
							}
							@case (ENABLE_PREVIEW_COLUMN.key) {
								<td>
									<button
										nz-button
										nzType="text"
										nzShape="circle"
										nzSize="small"
										title="Preview"
										(click)="preview(row)"
									>
										<span nz-icon nzType="pic-center" nzTheme="outline"></span>
									</button>
								</td>
							}

							@default {
								<td (click)="enableClickAsEdit() ? onEdit.emit(row) : onSelect.emit(row)">
									<ng-container
										*ngTemplateOutlet="
											cellMap.get(column.key);
											context: { $implicit: row, row: row }
										"
									></ng-container>
								</td>
							}
						}
					}
				</tr>
			}
		</tbody>

		<ng-template #totalTemplate let-total let-range="range">
			<span>{{ range[0] }}-{{ range[1] }} of {{ total }} rows</span>
		</ng-template>
	</nz-table>
</div>
